import React from 'react';
import { View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { Button, Dialog } from '../../components';
import Text from '../../components/text/Text';
import { getUnitsLabel } from '../../utils/unitsLabel';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import { SHORT_DATED_DAYS } from './PendingStockHelpers';
import PendingStockBatchRows from './PendingStockBatchRows';
import PendingStockScannerView from './PendingStockScannerView';
import { createPendingStockDialogStyles } from './PendingStockDialog.styles';

const PendingStockExcessScanDialog = ({
	isOpen,
	onClose,
	scannedProduct,
	scannedBarcode,
	warehouseProduct,
	rows,
	updateRow,
	addRow,
	removeRow,
	normalizedQuantity,
	isShortDated,
	canSubmit,
	onScanAgain,
	onSubmit,
	addLoading,
	cameraPermission,
	requestCameraPermission,
	onBarcodeScanned,
	productLookupLoading,
}) => {
	const styles = useThemedStyles(createPendingStockDialogStyles);

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			noPadding={!scannedProduct}
		>
			{scannedProduct ? (
				<View style={styles.dialogContainer}>
					<KeyboardAwareScrollView
						style={styles.dialogScroll}
						contentContainerStyle={styles.dialogContent}
						enableOnAndroid={true}
						extraScrollHeight={32}
						keyboardShouldPersistTaps="handled"
						showsVerticalScrollIndicator={false}
					>
						<Text style={styles.dialogTitle}>Add excess returned stock</Text>
						<Text style={styles.dialogMeta}>{scannedProduct.name}</Text>
						{scannedBarcode ? (
							<Text style={styles.dialogMeta}>Barcode: {scannedBarcode}</Text>
						) : null}
						<PendingStockBatchRows
							rows={rows}
							warehouseProduct={warehouseProduct}
							updateRow={updateRow}
							addRow={addRow}
							removeRow={removeRow}
							totalText={`Total quantity: ${normalizedQuantity} ${getUnitsLabel(normalizedQuantity)}`}
							disabled={addLoading}
						/>
						{isShortDated && (
							<Text style={styles.warningText}>
								Short dated: one or more expiry dates have less than {SHORT_DATED_DAYS} days remaining.
							</Text>
						)}
					</KeyboardAwareScrollView>
					<View style={styles.dialogActions}>
						<Button
							style={styles.dialogActionButton}
							label="Scan again"
							onPress={onScanAgain}
							disabled={addLoading}
						/>
						<Button
							style={styles.dialogActionButton}
							label="Add stock"
							onPress={onSubmit}
							secondary={true}
							loading={addLoading}
							disabled={!canSubmit || addLoading}
						/>
					</View>
				</View>
			) : (
				<PendingStockScannerView
					cameraPermission={cameraPermission}
					requestCameraPermission={requestCameraPermission}
					onBarcodeScanned={onBarcodeScanned}
					prompt="Scan an excess returned product."
					isLookingUpProduct={productLookupLoading}
				/>
			)}
		</Dialog>
	);
};

export default PendingStockExcessScanDialog;
